import React from 'react';
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ClassIcon from '@material-ui/icons/Class';
import MenuIcon from '@material-ui/icons/Menu';
import PaymentIcon from '@material-ui/icons/Payment';
import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 150;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  title: {
    textAlign: 'center',
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    '@media (max-width: 530px)': {
      display: 'none',
    },
  },
  // mobileDrawer: {
  //   width: drawerWidth,
  //   flexShrink: 0,
  // },
  drawerPaper: {
    width: drawerWidth,
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (max-width: 615px)': {
      padding: 0,
    },
  },
  avatarDiv: {
    display: 'flex',
    alignItems: 'baseline',
  },
  avatar: {
    marginRight: '10px',
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  sliderGroup: {
    display: 'flex',
    wrap: 'no-wrap',
  },
  slider: {
    width: theme.spacing(25),
    marginRight: '20px',
  },
  button: {
    marginBottom: '50px',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  menuButton: {
    display: 'none',
    '@media (max-width: 530px)': {
      display: 'inherit',
      position: 'fixed',
      top: 0,
      left: 12,
    },
  },
}));

const AccountLayout = ({ lang, children, changeToDisplay, toDisplay }) => {
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <List>
      <ListItem
        selected={toDisplay === 'info'}
        button
        onClick={() => changeToDisplay('info')}
      >
        <ListItemIcon>
          <AccountCircleIcon />
        </ListItemIcon>
        <ListItemText primary={lang === 'English' ? 'Account' : 'Cuenta'} />
      </ListItem>

      <ListItem
        selected={toDisplay === 'classes'}
        button
        onClick={() => changeToDisplay('classes')}
      >
        <ListItemIcon>
          <ClassIcon />
        </ListItemIcon>
        <ListItemText primary={lang === 'English' ? 'Classes' : 'Clases'} />
      </ListItem>

      <ListItem
        selected={toDisplay === 'payments'}
        button
        onClick={() => changeToDisplay('payments')}
      >
        <ListItemIcon>
          <PaymentIcon />
        </ListItemIcon>
        <ListItemText primary={lang === 'English' ? 'Payments' : 'Pagos'} />
      </ListItem>
    </List>
  );
  return (
    <div className={classes.root}>
      <IconButton
        color='inherit'
        aria-label='open drawer'
        edge='start'
        onClick={handleDrawerToggle}
        className={classes.menuButton}
      >
        <MenuIcon />
      </IconButton>
      <nav>
        <Drawer
          className={classes.mobileDrawer}
          variant='temporary'
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          {drawer}
        </Drawer>

        <Drawer
          className={classes.drawer}
          variant='persistent'
          anchor='left'
          open
        >
          {drawer}
        </Drawer>
      </nav>

      <main className={classes.content}>{children}</main>
    </div>
  );
};

export default AccountLayout;
